import { IDataBooking } from "../models/entities/IDataBooking";

const MockDataBooking: IDataBooking[] = [
  {
    id:0,
    email:"string",
    phone:"string",
    name:"string",
    nbPerson:0,
    hour:"string",
    date:"string"
  }
]

export default MockDataBooking;